/** Client-only copy. Server-enforced limits live in @virtual-office/shared. */

export const PASSWORD_MIN_HINT = 'At least 10 characters. Length beats punctuation.';
